import { ArchiveIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/shared/lib'

type EmptyStateProps = {
  /** Two or three words: «Пока пусто», «Ничего не найдено». */
  title: string
  /** Exactly one line: «Создайте первую запись — это займёт минуту.» */
  description?: string
  /** One action, no more. */
  action?: ReactNode
  icon?: ReactNode
  className?: string
}

/**
 * The dashed plate an empty list falls back to. Verdant gives it a title, one
 * line of copy and one action — never a second button and never an apology.
 */
export function EmptyState({ title, description, action, icon, className }: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        'flex flex-col items-center rounded-xl border border-dashed border-border-strong px-5 py-7 text-center',
        className,
      )}
    >
      <span className="mb-3.5 flex size-10 items-center justify-center rounded-full border border-veil/14 text-fg-secondary [&_svg]:size-4.5">
        {icon ?? <ArchiveIcon strokeWidth={1.5} />}
      </span>
      <p className="text-h3 font-medium">{title}</p>
      {description !== undefined && (
        <p className="mt-1.25 text-body text-muted-foreground">{description}</p>
      )}
      {action !== undefined && <div className="mt-3.5">{action}</div>}
    </div>
  )
}
